import SSFallbackImageResource from './002-slideshare_fallback_image_resource'
import SSBgImageResource from "./002-slideshare_bg_image_resource";
import SSHtmlResource from "./001-slideshare_html_resource"
import { isIos } from "../mobile/02-mobile_devices";


var isMobile = function () {
  var isMobile = navigator.userAgent.match(
    /iPhone|iPad|iPod|Android|BlackBerry|IEMobile|webOS|Mobile|Windows Phone/i
  );
  return isMobile;
};
/**
  * @class Base Class for Slides
  * @param {Object} config An options hash with settings for the Slide
  */
function SSSlide(config){
  if (typeof config === "undefined"){
    return;
  }

  this.index = config.index;
  this.realIndex = config.realIndex;

  // set Content Dimensions
  this.setContentDimensions(config.contentWidth, config.contentHeight);
  delete(config.contentWidth);
  delete(config.contentHeight);

  this.config = config;
  this._init();
}

SSSlide.prototype.setContentDimensions = function(width, height){
  this.contentWidth = width;
  this.contentHeight = height;
};

/**
  * Initializes the slide object
  * @private
  */

SSSlide.prototype._init = function(){
  this.status = 'initialized'; // make constants?

  this.controller = $.slideshareEventManager.getController();
  this.playerContainer = "#" + this.controller.config.container;
  this.$stage = $(this.playerContainer + ' .stage');
  this.$slide = this.$stage.find('.slide').eq(this.index - 1);
  this.$imageEle = this.$slide.children('.slide_image');

  this.viewModes = {};
  this.resources = {};

  this._createResources();
  this._bindEvents();
};

SSSlide.prototype.stop = function() {
  //
};

/**
  * Constructs urls for slide resources
  * @private
  */
SSSlide.prototype._createResources = function(){
  // this is for the standalone player, which doesn't necessarily have a
  // timestamp (in contrast to the webapp)
  if (typeof this.config.timestamp === 'undefined') {
    this.config.timestamp = (new Date()).getTime();
  }

  switch (this.config.slideMode){
    case 'image':
      var signature_hash = {};
      this.resources.image = new SSFallbackImageResource({
        baseUrl : this.config.bucketLocation,
        timestamp : this.config.timestamp,
        resourceKey : 'image',
        indexGenerator : this.config.indexGenerator,
        playerWidth : this.config.playerWidth,
        slideIndex : this.index,
        realIndex : this.realIndex,
        is_private : this.config.is_private,
        signatures : signature_hash,
        availableSizes : this.config.availableSizes,
        contentWidth : this.contentWidth,
        privateImageSignatures : this.config.privateImageSignatures ,
        conversionVersion : this.config.conversionVersion,
        isFullscreen : this.isFullscreen(),
        show_image_player : this.config.show_image_player
      });
      break;
    case 'html':
      this.resources.image = new SSBgImageResource({
        baseUrl : this.config.bucketLocation,
        availableSizes : this.config.availableSizes,
        timestamp : this.config.timestamp,
        resourceKey : 'image',
        indexGenerator : this.config.indexGenerator,
        playerWidth : this.config.playerWidth,
        slideIndex : this.index,
        realIndex : this.realIndex,
        is_private : this.config.is_private,
        contentWidth : this.contentWidth,
        conversionVersion : this.config.conversionVersion,
        privateImageSignatures : this.config.privateImageSignatures
      });
      this.resources.html = new SSHtmlResource({
        baseUrl : this.config.bucketLocation,
        timestamp : this.config.timestamp,
        resourceKey : 'html',
        indexGenerator : this.config.indexGenerator,
        slideIndex : this.index,
        realIndex : this.realIndex,
        is_private : this.config.is_private ,
        conversionVersion: this.config.conversionVersion,
        signature :  this.config.htmlResourceSignature
      });
      break;
  }
  delete(this.config.availableSizes);
};

/**
  * Call this to reset the Slide and its resources to its preloaded state.
  * For per slide reloading
  * @public
  */
SSSlide.prototype.reset = function(){
  this.status='initialized';
  var reskey;
  for (reskey in this.resources){
    const resource = this.resources[reskey].reset();
  }
};

/**
  * Call this to load the Slide and its resources.
  * @note Is safe to call multiple times
  * @public
  */
SSSlide.prototype.load = function(){
  if (this.status === 'cached'){
    // already have this in cache
    // fire off a call to image resource to update its versions
    this._getNewResourceVersions(this.currentViewMode.wrapperWidth);
    $.slideshareEventManager.trigger('slideloaded', {index : this.index });
    return;
  }

  if (this.status === 'loading'){
    $.slideshareEventManager.trigger('slideloading', {index : this.index });
    return;
  }
  if (this.status === 'failed'){
    // this slide has failed loading in the previous try.
    $.slideshareEventManager.trigger('slideloadfailed', {index : this.index });
    return;
  }
  // start the caching phase
  this.status = 'loading';
  $.slideshareEventManager.trigger('slideloading', {index : this.index });
  var that = this;
  var reskey;

  for (reskey in this.resources){
    const resource = this.resources[reskey];
    resource.status = 'loading';
    resource.load();
  }
};

/**
  * Set the status for a resource
  * @param {String} reskey The key for the resource out of the set of resources available to the slide
  * @param {Object} values Set of key/value pairs for properties of the resource to update
  */
SSSlide.prototype.updateResource = function(reskey, values){
  if (typeof this.resources[reskey] === 'undefined'){
    return;
  }
  this.resources[reskey].update(values);
};

/**
  * Updates the Slide Display Container with information that there was an error
  * @private
  */
SSSlide.prototype.displayError = function(jQueryDomObject, noRetry){
  this.empty();
  jQueryDomObject.appendTo(this.currentViewMode.wrapper);
  var that=this;
  var button = jQueryDomObject.find('input');
  if (noRetry){
    button.hide();
  } else {
    button.bind('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      that.reset();
      that.load();
    });
  }
};

/**
  * Updates display with Slide contents. To be called once slide has finished loading
  * @private
  */
SSSlide.prototype.paint = function(){
  if (typeof this.currentViewMode.imageElement === 'undefined'){
    this.render();
  }

  // Height is set to auto in the render function.
  this.currentViewMode.imageElement.css({
    width: this.currentViewMode.width
  });

  if (this.config.slideMode === 'html'){
    var zoomStyles;
    zoomStyles = {
      '-moz-transform' : 'scale(' + this.currentViewMode.contentScale + ')',
      '-webkit-transform' : 'scale(' + this.currentViewMode.contentScale + ')',
      '-o-transform' : 'scale(' + this.currentViewMode.contentScale + ')',
      'msTransform' : 'scale(' + this.currentViewMode.contentScale + ')',
      '-moz-transform-origin' : '0 0',
      '-webkit-transform-origin' : '0 0',
      '-o-transform-origin' : '0 0',
      'msTransformOrigin' : '0 0'
    };
    this.currentViewMode.contentElement.css({
      width: this.currentViewMode.width,
      height: this.currentViewMode.height
    });
    this.currentViewMode.contentElement.children('.ssml_div').css(zoomStyles);

    // Remove links if they are not enabled for this slide
    if (!this.areLinksEnabled()) {
      this.currentViewMode.contentElement.find('.ssml_a').remove();
    }
  }
};

SSSlide.prototype.isFullscreen = function(){
  return this.currentMode === 'fullscreen' || this.currentMode === 'nativefullscreen';
};

/**
  * Renders the contents of the slide into the Slide Display Container.
  *   Adds/Removes contents from Dom. Performance penalty when called repeatedly.
  *   Avoid using this where {@link paint()} would do
  * @private
  */
SSSlide.prototype.render = function() {
  this.empty();
  var imageEle, srcValue;
  var that = this;
  var currentPosition = $.slideshareEventManager.getCurrentPosition();
  var playerContainer = "#" + that.controller.config.container;
  switch(this.config.slideMode){
  case 'html':
    imageEle = $('<img/>').css({
      height: 'auto',
      position: 'absolute',
      top: 0,
      left: 0,
      margin: 0,
      padding: 0
    });
    srcValue = this.resources.image.getContent();
    break;
  case 'image':
    imageEle = this.$imageEle;
    if (this.isFullscreen() || this.$stage.width() > 640) {
      srcValue = this.$imageEle.data('full');
    } else if (this.$stage.width() <= 320) {
      srcValue = this.$imageEle.data('small');
    } else {
      srcValue = this.$imageEle.data('normal');
    }
    break;
  }

  if (typeof srcValue === "undefined") {
    return;
  }
  this.imageEle = imageEle;
  this.currentViewMode.imageElement = imageEle;

  // Load image.
  var image = new Image();

  image.onload = function () {
    if (typeof(startTime) != 'undefined' && typeof(_gaq) != 'undefined') {
      var loadTime = new Date() - startTime;
      _gaq.push(['_trackTiming', 'image', 'slide_load', loadTime, that.index.toString()]);
    }
    var currentPosition = that.controller.currentPosition;
    var oldHeight = that.$slide.height();
    var currentScrollTop = that.$stage.scrollTop();

    that.$slide.css("min-height", 0);

    if (typeof that.controller.firstLoad === "undefined") {
      that.controller.firstLoad = true;
    } else {
      that.controller.firstLoad = false;
    }

    that.currentViewMode.imageElement.attr({
      src: srcValue
    });

    // remove spinner for slide
    that.$slide.find('.fa-spinner').remove();

    //for infographics full size embeds if overflow is auto by default then
    // browsers leave space for toolbar even if not needed and the image dimensions
    //get distorted. By this overflow will be handled only if required. No CSS workaround
    //possible as we need to support smaller size embeds as well.
    if(that.config.playerType === "infographic"){
      that.addScrollIfNeeded();
    }

    // If document, the new image may change the height of the slide... we need to add the
    // height difference if the slide is before the current slide to avoid shifting.
    if (that.config.playerType === "document") {
      var heightDiff = that.$slide.height() - oldHeight;

      // If first image to load, set the default height for all slides to this
      // slide height.
      if (that.controller.firstLoad && !isMobile() &&
        that.controller.currentComponentSet.slidedisplayer.$slides) {
        that.controller.currentComponentSet.slidedisplayer.$slides.css("min-height", that.$slide.height());
        currentScrollTop += heightDiff * (currentPosition - 2);
      }

      if (that.index < currentPosition) {
        that.$stage.scrollTop(currentScrollTop + heightDiff);
      }
    }

    $(window).trigger('resize');

    // Postload
    var imageLoadedCallback = function(){
      that.loadLinks();
    };

    if (that.config.show_image_player) {
      if (document.readyState === 'complete') {
        imageLoadedCallback();
      } else {
        if(window.addEventListener) {
          window.addEventListener('load', imageLoadedCallback, false);
        } else if (window.attachEvent) {
          window.attachEvent('onload', imageLoadedCallback);
        }
      }
    }

    // Without this images flicker when animation ends in ios (for css3 animation)
    if(isIos()){
      $(this).css('-webkit-backface-visibility', 'hidden');
    }

    // Only fire resize events on the slideview page (not slideshelf or embed)
    if (that.config.hosted_in === 'slideview' && !that.config.show_image_player) {
      // Remove the height CSS on the image, so it'll revert to its natural size.
      // If the CSS height differs from the natural height,
      // then we know that the browser has resized the image.
      var cssHeight = $(this).height();
      $(this).css('height', 'auto');

      var naturalHeight = $(this).height();

      // // If the browser resizes the image, and we haven't already fired a GA alert,
      // // we should fire a GA alert.
      if (cssHeight !== naturalHeight && !window.slideResizeEventFired) {
        window.slideResizeEventFired = true;

        var preso_id = that.config.ssid;
        var slide_number = '00';
        var slideRegex = /slide-(\d+)-.*/;
        if (slideRegex.test(this.src)) {
          slide_number = this.src.match(slideRegex)[1];
        }
        var label = preso_id + '_slide_' + slide_number;

        $.slideshareEventManager.trackRawEvent('jsplayer_debug', 'slideresize', label);
      }
      // // Revert to the CSS height
      $(this).css('height', 'auto');
    }
  };

  image.src = srcValue;
  // Used for calculating image load time
  var startTime = new Date();

  if (!this.config.show_image_player) {
    imageEle.appendTo(this.currentViewMode.wrapper);
  }

  if (this.config.slideMode === 'html'){
    var styleData = '<style>' + this.resources.html.getContent().style + '</style>';
    $(styleData).appendTo(this.currentViewMode.wrapper);

    this.currentViewMode.contentElement = $('<div/>').css({
      position: 'absolute',
      overflow: 'hidden'
    }).html(this.resources.html.getContent().html);

    this.currentViewMode.contentElement.appendTo(this.currentViewMode.wrapper);
  }
};

//this function is created if infographic player (on embed) is fullsize or not
// if so then it adds the scroll
SSSlide.prototype.addScrollIfNeeded = function(){
  var tolerance = 15;
  if(this.$imageEle.height() > this.$slide.height() + tolerance){
    this.$slide.css('overflow-y', 'auto');
  }
};

// Returns whether links are disabled for this slide
//   1) Link override OR super user --> TRUE
//   2) On the first three slides --> FALSE
//   3) Every other slide --> TRUE
SSSlide.prototype.areLinksEnabled = function() {
  if(this.config.is_render_all_links ||
    (typeof slideshare_object !== 'undefined' && slideshare_object.user.su)) {
    return true;
  } else if($.inArray(this.index, [1,2,3]) !== -1) {
    return false;
  } else {
    return true;
  }
};

SSSlide.prototype.loadLinks = function () {
  var that = this;
  $.jsonp({
    url : that.config.bucketLocation + '/meta.js?' + this.config.timestamp,
    callback : 'slideshare_jsonp_meta_hook_trigger',
    cache : true,
    timeout : 10000,
    success : function(meta) {
      that.controller.links = meta.links;
      that.controller.linksLoaded = true;
      that.controller.clickGenTracker.registerLinksMetadata(meta.links);
      that.controller.slideAspectRatio = meta.sizes[1].height/meta.sizes[1].width;
      that.controller.updateEmbedSizes();
    }
  });
};

SSSlide.prototype._getNewResourceVersions = function(){
  // resource version to be done only for images
  this.resources.image._tryLoad(this.currentViewMode.wrapperWidth);
};

SSSlide.prototype.updateRenderedResourceVersion = function(resourceKey){
  if (!this.currentViewMode.rendered){
    return;
  }

  // resource version to be done only for images
  if (resourceKey === 'image' && this.currentViewMode.imageElement !== undefined){
    this.currentViewMode.imageElement.attr({
      src : this.resources.image.getContent()
    });
  }
};

/**
  * Binds EventHandlers to the Slide.
  * @private
  * @note Call only once per slide
  */
SSSlide.prototype._bindEvents = function(){
  // noop
};

export default SSSlide;
